export const mainLayoutStyles = {
  root: {
    display: 'flex',
    height: '100vh',
  },
  appBar: {
    zIndex: 1201,
  },
  title: {
    flexGrow: 1,
    fontWeight: 'bold',
    cursor: 'pointer',
    userSelect: 'none',
    fontFamily: "'Caveat', cursive",
    fontSize: '2rem',
    '&:hover': {
      opacity: 0.8,
    },
    '&:active': {
      opacity: 0.6,
    },
  },
  menuButton: {
    marginLeft: 'auto',
  },
  drawer: {
    zIndex: 1200,
  },
  drawerContent: {
    width: 280,
    height: '100%',
    display: 'flex',
    flexDirection: 'column' as const,
    padding: '1rem',
    paddingTop: '80px',
  },
  menuList: {
    flexGrow: 1,
  },
  logoutSection: {
    marginTop: 'auto',
    paddingTop: '1rem',
    borderTop: '1px solid #e0e0e0',
  },
  content: {
    flexGrow: 1,
    overflow: 'auto',
    padding: '0rem',
  },
};